(function ($, Drupal) {

  'use strict';

  /**
   * Fixes pagination behavior for FSA component.
   */
  Drupal.behaviors.paginationFox = {
    attach: function (context) {
      // FSA component starts pager numeration from 1. In Drupal it
      // starts from 0, so we need to reduce each data value after it's
      // rendered.
      $('nav.pagination', context).find('a').each(function() {
        const index = Number.parseInt($(this).attr('data-page'), 10) || 1;
        $(this).attr('data-page', index - 1);
      });
    }
  }

  /**
   * Adds "opens in new browser window" to external links.
   */
  Drupal.behaviors.titleForExternalLinks = {
    attach: function (context) {
      // Must be applied after extlink module logic.
      setTimeout(function() {
        $('.content a.external-link[target="_blank"]', context).each(function() {
          $(this).append(`<span class="visually-hidden">(${Drupal.t('Open in a new window')})</span>`);
        });
      }, 0);
    }
  }
})(jQuery, Drupal);
